$.fn.carousel = (function () {

  if (window.innerWidth > 1200) {
    var showCount = 6;
    var shiftCount = 6;
  } else {
    var showCount = 5;
    var shiftCount = 5;
  }

  var firstItem = 0;
  var lastItem = showCount - 1;
  var carouselItem = this.find('.js-carousel__item');
  var classItemActive = 'u-inline-block';
  var classActionActive = 'shown';
  var classFirst = 'is-first';
  var classLast = 'is-last';
  var actionForward = this.find('.js-carousel-forward');
  var actionBackward = this.find('.js-carousel-backward');

  function addCarouselClasses(showCount, shiftCount, firstItem, lastItem) {
    $(carouselItem).each(function (index) {
      if (index >= firstItem && index <= lastItem) {
        $(this).addClass(classItemActive);
      }
      if (index === firstItem && !carouselItem.hasClass('js-carousel__item--no-expand')) {
        $(this).addClass(classFirst);
      }
      if (index === lastItem) {
        $(this).addClass(classLast);
      }
      if (firstItem >= showCount) {
        $(actionBackward).addClass(classActionActive);
      } else {
        $(actionBackward).removeClass(classActionActive);
      }
      if (firstItem > (index - showCount)) {
        $(actionForward).removeClass(classActionActive);
      } else {
        $(actionForward).addClass(classActionActive);
      }
    });
  }

  addCarouselClasses(showCount, shiftCount, firstItem, lastItem);

  $(actionForward).on('click', function () {
    forwardFirst = firstItem + shiftCount;
    forwardLast = lastItem + shiftCount;
    $(carouselItem).removeClass(classItemActive);
    $(carouselItem).removeClass(classFirst);
    $(carouselItem).removeClass(classLast);
    addCarouselClasses(showCount, shiftCount, forwardFirst, forwardLast);
    firstItem = forwardFirst;
    lastItem = forwardLast;
  });

  $(actionBackward).on('click', function () {
    backwardFirst = firstItem - shiftCount;
    backwardLast = lastItem - shiftCount;
    $(carouselItem).removeClass(classItemActive);
    $(carouselItem).removeClass(classFirst);
    $(carouselItem).removeClass(classLast);
    addCarouselClasses(showCount, shiftCount, backwardFirst, backwardLast);
    firstItem = backwardFirst;
    lastItem = backwardLast;
  });

});

$(document).ready(function() {

  if (window.innerWidth > 992) {
    // Enable carousel after our large breakpoint
    $('.js-hover-carousel').each(function () {
      $(this).carousel();
    });
    document.addEventListener("js-home-practice-loaded", function() {
      $('.js-hover-carousel').each(function () {
        $(this).carousel();
      });
    });
    document.addEventListener("js-home-projects-loaded", function() {
      $('.js-hover-carousel').each(function () {
        $(this).carousel();
      });
    });
  }
});

var optimizedResize = (function () {

  var callbacks = [],
    running = false;

  // fired on resize event
  function resize() {

    if (!running) {
      running = true;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }

  }

  // run the actual callbacks
  function runCallbacks() {

    callbacks.forEach(function (callback) {
      callback();
    });

    running = false;
  }

  // adds callback to loop
  function addCallback(callback) {

    if (callback) {
      callbacks.push(callback);
    }

  }

  return {
    // public method to add additional callback
    add: function (callback) {
      if (!callbacks.length) {
        window.addEventListener('resize', resize);
      }
      addCallback(callback);
    }
  }

}());

// start process
optimizedResize.add(function () {
  if (window.innerWidth > 992) {
    // Enable carousel after our large breakpoint
    $('.js-hover-carousel').each(function () {
      $(this).carousel();
    });
  }
});
